import clsx from "clsx";

interface PortalNotificationActionAreaI {
  to: string;
  text: string;
  className?: string;
}

export default function PortalNotificationActionArea({
  text,
  to,
  className,
}: PortalNotificationActionAreaI) {
  return (
    <a
      className={clsx("flex items-center gap-2 h-8", className)}
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={text}
    >
      <span className="w-5 h-5 icon-[eva--external-link-outline] flex-none" />
      <span className="text-sm">{text}</span>
    </a>
  );
}
